<!-- About Component -->

<template>
  <div class="about-page">
    <div>
      <el-row :gutter="0" class="m-0">
        <top-navigation></top-navigation>
        <el-col :span="24" class="article-featured px-0">
          <div class>
            <div class="become-page__header small-header">
              <div class="header__content__bg"></div>
              <div class="header__image__bg become-gs-bg"></div>
              <div class="header__content container">
                <el-row class="pb-3">
                  <el-col :md="24" :lg="12">
                    <div class="header__content__wrapper">
                      <h1 id="main-content" class="header__title">
                        {{ text.headingText }}
                      </h1>
                      <h2 class="header__content-info">
                        {{ text.headingSub }}
                      </h2>
                    </div>
                  </el-col>
                </el-row>
                <el-row class="pb-3">
                  <el-col :md="24" :lg="12">
                    <el-button
                      class="btn-text"
                      type="primary"
                      size="small"
                      @click="$router.push({ name: 'Signup GS' })"
                    >
                      Get Started
                    </el-button>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div>
        <what-does-it-involve></what-does-it-involve>
      </div>
      <!--div>
        <how-does-it-work></how-does-it-work>
      </div-->
      <div>
        <how-can-you-help></how-can-you-help>
      </div>
      <div>
        <how-do-i-become></how-do-i-become>
      </div>
    </div>
  </div>
</template>

<script>
import TopNavigation from "../../layout/top-navigation";
import WhatDoesItInvolve from "../../pages/landing/becoming/what-does-it-invlolve";
//import HowDoesItWork from "../../pages/landing/becoming/how-does-it-work";
import HowCanYouHelp from "../../pages/landing/becoming/how-can-you-help";
import HowDoIBecome from "../../pages/landing/becoming/how-do-i-become";
export default {
  name: "BecomeService",
  metaInfo: {
    title: "Becoming a Service",
    meta: [
      {
        name: "description",
        content:
          "Have you got the skills, experience and connections to support Scottish businesses? Find out more about becoming a Service.",
      },
    ],
  },
  components: {
    WhatDoesItInvolve,
    TopNavigation,
    //HowDoesItWork,
    HowCanYouHelp,
    HowDoIBecome,
  },
  data() {
    return {
      text: {
        headingText: "Become a Service",
        headingSub:
          "Got the skills, experience and professional networks to support Scottish businesses?",
      },
    };
  },
};
</script>
